import { useContext } from "react";

import { AuthContext } from "@/contexts/authContext";

export const useOptionalUser = () => {
  const authContext = useContext(AuthContext);
  return authContext.currentUser;
};
